import { render, staticRenderFns } from "./AllotmentsTab.vue?vue&type=template&id=b52af9e8&scoped=true"
import script from "./AllotmentsTab.vue?vue&type=script&lang=js"
export * from "./AllotmentsTab.vue?vue&type=script&lang=js"
import style0 from "./AllotmentsTab.vue?vue&type=style&index=0&id=b52af9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52af9e8",
  null
  
)

export default component.exports